module.exports = __webpack_public_path__ + "static/media/down-arrow-blue.757fab20.svg";